import React, {useEffect} from "react";
import {Query} from "../HealthcareUsageReport/types/CohortQuery";
import _ from "lodash";
import {Project} from "../../types/Project";
import CohortSummaryReport from "./CohortSummaryReport";
import {EditStudyContent} from "./EditStudyContent";
import {Route, Switch, useRouteMatch} from "react-router-dom";
import {Routes} from "../../pages/routes";
import {CohortTimeframe} from "../../components/cohort-timeframe/CohortTimeframe";
import {Next, Run, Save} from "./Actions";
import {DescriptiveStats} from "./DescriptiveStats";
import {StudyLayout} from "./StudyLayout";
import {EditCriteriaLayout} from "./EditCriteria/EditCriteriaLayout";
import {StudyActions} from "./StudyActions";

export const ScrollOnMount = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return null
}

export const StudyContent: React.FC<{project: Project, study: Query}> = ({project, study}) => {
    const editable = _.isNil(study.sparkQuery)
    const { path } = useRouteMatch(Routes.Project)

    return <Switch>
        <Route path={`${path}/period`}>
            <StudyLayout title={"Study Period"} floatSidebar={false}>
                <ScrollOnMount />
                <StudyActions
                    project={project}
                    study={study}
                    secondaryAction={editable ? <Next study={study}/> : undefined}
                />
                <CohortTimeframe/>
            </StudyLayout>
        </Route>
        <Route path={`${path}/criteria`}>
            <EditCriteriaLayout project={project} study={study}/>
        </Route>
        <Route path={`${path}/stats`}>
            <StudyLayout title={"Descriptive Statistics"} floatSidebar={true}>
                <DescriptiveStats project={project} />
            </StudyLayout>
        </Route>
        <Route>
            <StudyLayout title={"Cohort"} floatSidebar={false}>
                <StudyActions
                    project={project}
                    study={study}
                    primaryAction={<Run study={study}/>}
                    secondaryAction={editable ? <Save studyId={study.id}/> : undefined}
                />
                { editable ? <EditStudyContent study={study}/> : <CohortSummaryReport/> }
            </StudyLayout>
        </Route>
    </Switch>
}